export function useHomePath() {
  return '/';
}
